module.exports = __webpack_public_path__ + "img/8pll.efa029ed.png";